import { cn } from '@/utils/cn'
import { isContractTabVisible, isProposalTabVisible } from '../deals-constants'
import type { Deal } from '@/types'
import { panelTabs, type PanelTab } from './dealDetailPanelConfig'

type DealDetailPanelTabsProps = {
  deal: Deal
  activeTab: PanelTab
  onTabChange: (tab: PanelTab) => void
}

export function DealDetailPanelTabs({ deal, activeTab, onTabChange }: DealDetailPanelTabsProps) {
  const visibleTabs = panelTabs.filter((tab) => {
    if (tab.id === 'proposal') return isProposalTabVisible(deal.etapa)
    if (tab.id === 'contract') return isContractTabVisible(deal.etapa)
    return true
  })

  return (
    <nav
      className="flex shrink-0 items-center gap-1 border-b border-white/[0.06] bg-bg-main/95 px-4 py-2 backdrop-blur-sm"
      role="tablist"
      aria-label="Seções do deal"
    >
      {visibleTabs.map((tab) => (
        <button
          key={tab.id}
          type="button"
          role="tab"
          aria-selected={activeTab === tab.id}
          onClick={() => onTabChange(tab.id)}
          className={cn(
            'flex flex-1 items-center justify-center gap-1.5 rounded-md px-2.5 py-2 text-xs font-medium transition-all',
            activeTab === tab.id
              ? 'bg-accent text-white shadow-sm'
              : 'text-text-muted hover:bg-white/[0.05] hover:text-text-primary',
          )}
        >
          <tab.icon size={14} aria-hidden />
          {tab.label}
        </button>
      ))}
    </nav>
  )
}
